import { createPortal } from 'react-dom';
import { CloseIcon } from '@components/icons';
import { ExportContent } from './export/export-content';

interface ExportModalProps {
  onClose: () => void;
}

/**
 * Export & Import modal — opened from the study panel download button.
 * Rehosts the existing ExportContent unchanged. Portaled to document.body:
 * modals are application-modal, and a panel ancestor's backdrop-filter
 * would otherwise contain the fixed overlay.
 */
export function ExportModal({ onClose }: ExportModalProps) {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative flex max-h-[85vh] w-full max-w-md flex-col rounded-2xl bg-white p-6 shadow-xl dark:bg-stone-800">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-stone-800 dark:text-stone-200">
            Export & Import
          </h2>
          <button
            onClick={onClose}
            className="p-1.5 text-stone-400 transition-colors hover:text-stone-600 dark:hover:text-stone-300"
            title="Close"
          >
            <CloseIcon className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="min-h-0 flex-1 overflow-y-auto">
          <ExportContent />
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default ExportModal;
